export default __webpack_public_path__ + "static/messi-sm-728702958e164a0d4af948c046cedd9b.png";